import React, { FC } from 'react';
import { getProductionBatchByProductionOperationId, operationsSearch } from '@reducers/search';
import { updateHeaderConfig } from '@reducers/details';
import { connect } from 'react-redux';
import { useTitle } from '@v2/pages/common/hooks/useTitle';
import { useJobDetails } from '@v2/pages/common/hooks/useJobDetails';
import { getNCFilesByProductionOperationId } from '@reducers/manufacture';
import JobContentWrapper from '@v2/pages/job/common/components/JobContentWrapper';
import MultiMachineTimeline from '@v2/pages/common/components/MultiMachineTimeline';
import { useRoute } from '@react-navigation/native';
import { isRouteParamTruthy } from '@helpers';

interface JobDetailsNCFileTimelineProps {
}

const JobDetailsNCFileTimelineComponent: FC<JobDetailsNCFileTimelineProps> = ({
  updateHeaderConfig,
  operationsSearch,
  getNCFilesByProductionOperationId,
  getProductionBatchByProductionOperationId,
}) => {
  const title = useTitle();

  useJobDetails({
    updateHeaderConfig,
    operationsSearch,
    getNCFilesByProductionOperationId,
    getProductionBatchByProductionOperationId,
    getAllNcFiles: false,
  });

  const route = useRoute();
  
    const keepList = route?.params?.keepList;
    const shouldDisplayFullScreenTimeline = !isRouteParamTruthy(keepList);

  return (
    <JobContentWrapper loading={false} title={title.ncFile}>
      <MultiMachineTimeline fullScreen={shouldDisplayFullScreenTimeline} />
    </JobContentWrapper>
  );
};

const JobDetailsNCFileTimeline = connect(null, {
  updateHeaderConfig,
  operationsSearch,
  getNCFilesByProductionOperationId,
  getProductionBatchByProductionOperationId,
})(JobDetailsNCFileTimelineComponent);

export { JobDetailsNCFileTimeline };
